{
	"default": {
		"summary": "A powerful CLI tool for packaging Node.js dependencies into AWS Lambda Layers. Creates optimized .zip archives compatible with AWS Lambda, Terraform, and Serverless Framework deployments.",
		"description": "Welcome to Lambda Layer Packager - Simplify your serverless deployments!"
	},
	"commands": {
		"summary": "Available CLI operations",
		"description": "Manage Lambda Layer packaging with intuitive commands for dependency bundling and deployment preparation."
	},
	"package": {
		"summary": "Create Lambda Layer packages",
		"description": "Bundle Node.js dependencies into an AWS Lambda Layer-compatible archive, optimized for serverless deployments."
	}
}
